import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useT } from "../features/UseT";
import "./PrivacyPolicyScreen.css";

function PrivacyPolicyScreen() {
  const t = useT();
  const lang = useSelector((s) => s.language.current);
  const [ppHtml, setPpHtml] = useState({});
  useEffect(() => {
    if (!lang) return;
    fetch(`/longtxt/privacypolicy.json`)
      .then((res) => res.json())
      .then((data) => setPpHtml(data))
      .catch(console.error);
  }, [lang]);
  return (
    <div className="PrivacyPolicyScreen">
      <a href="/" className="Back">
        <span>{`<< ${t.sdb}`}</span>
      </a>
      <span className="PrivacyTitle">{ppHtml.title_en}</span>
      <span
        className="PrivacyPolicy"
        dangerouslySetInnerHTML={{ __html: ppHtml.en }}
      />
    </div>
  );
}

export default PrivacyPolicyScreen;
